import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { roomsApi as r } from "@maat/api-main";
//#region src/rooms/useCreateRoomsMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ unitId: e, ...t }) => r.createRooms(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.property() }), i.invalidateQueries({ queryKey: e.unit() });
		}
	});
};
//#endregion
export { i as useCreateRoomsMutation };
